import { Component } from '@angular/core'
import { Subject, takeUntil, throttleTime } from 'rxjs'
import { LocationService } from 'src/app/core/services/location.service'
import { MapService } from 'src/app/core/services/map.service'
import { Marker } from 'maplibre-gl'

@Component({
  selector: 'app-map-navigation',
  templateUrl: './map-navigation-base.component.html',
  styleUrls: ['./map-navigation-base.component.scss'],
  standalone: false,
})
export class MapNavigationComponent {
  public rotateIcon: number = 0
  public isLocationRefreshEnabled = false
  private cleanUp$ = new Subject<void>()
  private marker: Marker
  private height: number = 0

  constructor(
    public readonly mapService: MapService,
    private locationService: LocationService,
  ) {
    const el = document.createElement('div')
    el.className = 'position-circle-marker'
    el.id = 'marker1'
    this.marker = new Marker(el)

    this.mapService.map.on('rotate', () => {
      this.rotateIcon = this.mapService.map.getBearing()
    })
    this.height = this.mapService.map.getContainer().clientHeight
  }
  toggleAutoRefresh = async () => {
    this.isLocationRefreshEnabled = !this.isLocationRefreshEnabled
    this.height = this.mapService.map.getContainer().clientHeight
    if (this.isLocationRefreshEnabled) {
      this.locationService.initialize()
      this.locationService.configure()
      this.mapService.map.setPitch(40)
      this.mapService.map.setZoom(16)
      this.locationService.positionChanged$
        .pipe(throttleTime(1000, undefined, { leading: true, trailing: true }))
        .pipe(takeUntil(this.cleanUp$))
        .subscribe((position) => {
          if (this.isLocationRefreshEnabled) {
            this.marker.remove()
            this.mapService.map.easeTo({
              padding: { top: this.height * 0.8 },
              center: position.exact,
              bearing: this.locationService.getHeading() || 0,
            })
            this.marker.setLngLat(position.exact).addTo(this.mapService.map)
          }
        })
    } else {
      this.isLocationRefreshEnabled = false
      this.locationService.stopWatchingPosition()
      this.mapService.map.resetNorthPitch()
      this.marker.remove()
      this.cleanUp$.next()
    }
  }

  ngOnDestroy(): void {
    this.locationService.stopWatchingPosition()
    this.marker.remove()
  }

  rotateNorth() {
    this.mapService.map.resetNorthPitch()
  }

  switchOsmView(): void {
    this.mapService.switchOsmView()
  }
}
